import {createRouter, createWebHistory} from 'vue-router';
import Start from "../views/Start.vue";
import Next from "../views/Next.vue";
import ChooseType from "../views/ChooseType.vue";
import Danke from "../views/Danke.vue";
import DankeGuarantee from '../views/DankeGuarantee.vue';
import Sorry from '../views/Sorry.vue'

const routes = [
    {
        path: "/app/start",
        name: "choosetype",
        component: ChooseType,
        props: route => ({ id: route.query.id})
    },
    {
        path: "/app/start-buergschaft",
        name: "startbuergschaft",
        component: Start,
        props: route => ({ id: route.query.id, new: route.query.new})
    },
    {
        path: "/app/start-reservierung",
        name: "reservierung",
        component: Start,
        props: route => ({ id: route.query.id, new: route.query.new})
    },
    {
        path: "/app/next",
        name: "next",
        component: Next,
        props: route => ({ id: route.query.id})
    },
    {
        path: "/app/danke-reservierung",
        name: "dankereservierung",
        component: Danke,
        props: route => ({ id: route.query.id})
    },
    {
        path: "/app/danke-guarantee",
        name: "dankeguarantee",
        component: DankeGuarantee,
        props: route => ({ id: route.query.id})
    },
    {
        path: "/app/sorry",
        name: "sorry",
        component: Sorry,
    },
    {
        path: "/app/:catchAll(.*)",
        name: "choosetype",
        component: ChooseType,
    },
];

const router = new createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0)
    },
})

export default router;
